import axios from "../axios/axios";
import { setTransactions } from "../store/actions/transactionAction";
import { apiSetAlert } from "./appApi";
import { selectTableItems } from "../store/actions";
import { appSetLoading, appSetSendingRequest } from "../store/actions/appAction";
import { errorDispatcher, formatDate, getOptionsQuery } from "../helpers";
import { setTableData } from "../store/actions/dataTableAction";
import fileDownload from "js-file-download";
import { setSalesByFactor } from "../store/actions/reportAction";
import { DateToString } from "components/Reports/DateFilter";

export const apiGetTransactionsExcel = (token, transactionType, selectedIds) => (dispatch, getState) => {
  let url = `transactions/excel/export?transactionType=${transactionType}`;
  if (selectedIds && selectedIds.length > 0) {
    url += `&ids=[${selectedIds}]`;
  }
  dispatch(appSetLoading());
  axios
    .get(url, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
    })
    .then((response) => {
      dispatch(appSetLoading(false));
      const now = DateToString(Date.now()).replace("/", "_");
      const fileName = transactionType ? `${transactionType}s_${now}` : `transactions_${now}`;
      fileDownload(response.data, `${fileName}.xlsx`);
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiGetTransaction =
  (transactionId, transactionType, token, callback) => (dispatch, getState) => {
    dispatch(appSetLoading());
    axios
      .get(`transactions/${transactionId}?transactionType=${transactionType}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        callback(response.data);
        dispatch(appSetLoading(false));
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
  };

export const apiGetTransactions =
  ({ pagination, token, key, sort, search }) =>
  (dispatch, getState) => {
    let transactionType = key;
    let url = `/transactions/list`;

    if (transactionType) {
      url += `?transactionType=${typeof transactionType === "string" ? transactionType : "receive"}`;
    } else {
      return;
    }

    let options = getOptionsQuery(pagination, search, sort);

    dispatch(appSetLoading());
    axios
      .post(url, options, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        dispatch(setTableData(response.data.transactions, response.data.paginate));
        // dispatch(setTransactions(response.data.transactions));
        dispatch(appSetLoading(false));
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
  };

export const apiDeleteTransactions = (selectedIds, token, type, callback) => (dispatch, getState) => {
  dispatch(appSetLoading());
  dispatch(appSetSendingRequest());
  const transactionIds = selectedIds;
  const transactionType = type.key;
  axios
    .delete(`/transactions/multiple/delete`, {
      headers: { Authorization: `Bearer ${token}` },
      data: { transactionIds, transactionType },
    })
    .then((response) => {
      dispatch(selectTableItems([]));
      dispatch(apiSetAlert(response.data.message, "success"));
      if (callback) callback();
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiSaveTransaction = (form, token, nextStep, fd, cb) => (dispatch, getState) => {
  const businessCurrencyId = getState().businessReducer.business.business.default_currency_id;
  const transactionCurrency = form.transactionCurrency;
  let currencyExchange = 1;

  if (transactionCurrency && transactionCurrency.id !== businessCurrencyId) {
    currencyExchange = getState().currencyReducer.businessCurrencies.find(
      (bc) => bc.id === form.transactionCurrency.id
    ).currencyExchange;
  }

  const financialTypes = ["bank", "fund", "cashier"];
  const firstItems = [];
  const secondItems = [];

  form.source?.map((p) => {
    if (p.key && p.value && p.price) {
      firstItems.push({
        amount: +p.price,
        wage: +p.wage ?? 0,
        optionableId: +p.value,
        optionableType: financialTypes.includes(p.key) ? "financial" : p.key,
      });
    }
  });

  form.destination?.map((r) => {
    if (r.key && r.value && r.price) {
      secondItems.push({
        amount: +r.price,
        wage: +r.wage ?? 0,
        optionableId: +r.value,
        optionableType: financialTypes.includes(r.key) ? "financial" : r.key,
        chequeDate: r.key === "cheque" || r.key === "spendCheque" ? formatDate(r.date) : undefined,
        chequeIssuingBank: r.key === "cheque" || r.key === "spendCheque" ? r.bank : undefined,
        chequeBranch: r.key === "cheque" || r.key === "spendCheque" ? r.branch : undefined,
        chequeNumber: r.key === "cheque" || r.key === "spendCheque" ? parseInt(r.number) : undefined,
      });
    }
  });

  const formData = {
    transaction: {
      accountingCode: form.accountingCodeType ? null : form.accountingCode ?? null,
      date: form.date ? formatDate(form.date) : null,
      description: form.description ?? null,
      ProjectId: form.Project?.id ?? null,
      BranchId: form.Branch?.id ?? null,
      transactionType: form.type ?? "receive", //receive, payment, cost, income
      factorId: form.factor?.id ?? null,
      currencyId: form?.transactionCurrency?.id ?? null,
      currencyExchange,
    },
    firstItems: firstItems,
    secondItems: secondItems,
  };
  //const url = form.factor || fd.transaction.factorId ? "transactions/factor/transaction" : "/transactions";
  const url = form.factor ? "transactions/factor/transaction" : "/transactions";
  dispatch(appSetSendingRequest(true));
  axios
    .post(url, fd || formData, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(apiSetAlert(response.data.message, "success"));
      cb && cb(response.data);
      nextStep && nextStep();
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiSaveInstallmentTransaction = (token, formData, callback) => (dispatch, getState) => {
  const url = "transactions/installment/transaction";

  dispatch(appSetSendingRequest(true));
  axios
    .post(url, formData, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(apiSetAlert(response.data.message, "success"));
      callback();
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiUpdateInstallmentTransaction = (id, form, token, nextStep,formData,callback) => (dispatch, getState) => {
  const url = `transactions/installment/transaction/${id}`;
  dispatch(appSetSendingRequest(true))
  axios.put(
    url,
    formData,
    {
    headers: {Authorization: `Bearer ${token}`}
  }).then((response) =>{
    dispatch(apiSetAlert((response.data.message,"success")))
    callback()
  })
    .catch(error => {
      errorDispatcher(error,dispatch)
    })
}

export const apiUpdateTransaction =
  (transactionId, form, token, nextStep, fd, cb) => (dispatch, getState) => {
    const financialTypes = ["bank", "fund", "cashier"];
    const firstItems = [];
    const secondItems = [];

    form.source?.map((p) => {
      if (p.key && p.value && p.price) {
        firstItems.push({
          amount: +p.price,
          wage: +p.wage ?? 0,
          optionableId: +p.value,
          optionableType: financialTypes.includes(p.key) ? "financial" : p.key,
        });
      }
    });

    form.destination?.map((r) => {
      if (r.key && r.value && r.price) {
        secondItems.push({
          amount: +r.price,
          wage: +r.wage ?? 0,
          optionableId: r.key === "cheque" ? +r.cheque.id : +r.value,
          optionableType: financialTypes.includes(r.key) ? "financial" : r.key,
          chequeDate: r.key === "cheque" || r.key === "spendCheque" ? formatDate(r.date) : undefined,
          chequeIssuingBank: r.key === "cheque" || r.key === "spendCheque" ? r.bank : undefined,
          chequeBranch: r.key === "cheque" || r.key === "spendCheque" ? r.branch : undefined,
          chequeNumber: r.key === "cheque" || r.key === "spendCheque" ? parseInt(r.number) : undefined,
        });
      }
    });

    const formData = {
      transaction: {
        accountingCode: form.accountingCodeType ? null : form.accountingCode ?? null,
        date: form.date ? formatDate(form.date) : null,
        description: form.description ?? null,
        ProjectId: form.Project?.id ?? null,
        BranchId: form.Branch?.id ?? null,
        transactionType: form.type ?? "receive", //receive, payment, cost, income
        factorId: form.factor?.id ?? null,
        currencyId: form?.transactionCurrency?.id ?? null,
        currencyExchange: 1,
      },
      firstItems: firstItems,
      secondItems: secondItems,
    };
    dispatch(appSetSendingRequest(true));
    axios
      .put(`transactions/${transactionId}`, fd || formData, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        dispatch(apiSetAlert(response.data.message, "success", false));
        if (cb) {
          cb(response.data);
          return;
        }
        nextStep();
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
  };
